import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getUserTypes } from '../../../Constant'
import axios from 'axios'
import moment from 'moment'
import BookingHistory from './BookingHistoryList'
import WalletHistory from './WalletHistoryList'
import LoyaltyPointHistory from './LoyaltyPointsHistory'
import VoucherHistory from './VoucherHistoryList'
import RechargeHistory from './RechargeHistoryList'
import HasPermission from '../../../common/Permissions/HasPermission'
import Select from 'react-select'
import Button from '../../../common/CustomComponents/Button'

class AddNewUser extends React.Component {
  state = {
    id: null,

    nationality_list: [],
    ownerList: [],
    pickupList: [],
    pickup_data: null,
    captain_alloted_to: '',
    nationality: '',

    first_name: '',
    last_name: '',
    first_name_ar: '',
    last_name_ar: '',
    phone: '',
    email: '',
    password: '',
    user_profile: '',
    country_code: '',
    user_type: 'admin',
    gender: 'M',
    dob: null,
    token: '',

    Edit: false,

    img: './assets/images/no_image.png',

    isLoading: false,

    selected_tab: 'booking-history',
    user_tabs: [
      { value: 'booking-history', label: 'Booking History' },
      { value: 'user-wallet', label: 'Wallet History' },
      { value: 'voucher-list', label: 'Voucher List History' },
      { value: 'recharge-list', label: 'Recharge List History' },
      { value: 'user-loyalty-points', label: 'Loyalty Points History' },
    ],
    created_at: '',
    concierge_company_name: '',
    ops_sup_users: [
      'admin',
      'captain',
      'store',
      'chalet-owner',
      'event-vendor',
      'vendor',
      'ops-coord',
      'ops-sup',
      'concierge',
      'car-owner',
    ],
    ops_cord_users: ['admin', 'captain', 'store', 'chalet-owner', 'event-vendor', 'vendor', 'concierge', 'car-owner'],
    countryList: [],
    nationalityData: null, // used for user nationality purpose not for captain
    countryCodes: [],
    countryCodeData: null,
  }

  async componentDidMount() {
    await this.getCountryList()
    this.getPickupList()
    if (!HasPermission('manage-voucher')) {
      this.setState({
        user_tabs: this.state.user_tabs.filter((item) => item.value != 'voucher-list'),
      })
    }

    if (this.props?.match?.params?.action == 'edit' && this.props?.match?.params?.id) {
      this.setState(
        {
          id: this.props.match?.params?.id,
        },
        () => {
          this.loadUserData()
        }
      )
    }
    this.getOwnerList()
    this.getNationalityList()
  }

  getUserType = () => {
    const allUserTypes = getUserTypes()
    const role = localStorage.getItem('loged_In_role')

    const userRoleMap = {
      'ops-sup': this.state.ops_sup_users,
      'ops-coord': this.state.ops_cord_users,
    }

    if (userRoleMap[role]) {
      return allUserTypes.filter((userType) => userRoleMap[role].includes(userType.value))
    }

    if (['owners', 'super-admin'].includes(role)) {
      return allUserTypes
    }

    return []
  }

  loadUserData = async () => {
    await axios
      .get(Constant.getAPI() + `/user/get-user/${this.state.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((data) => {
        this.setState({ isLoading: false })
        if (data?.data?.success == true) {
          const userData = data?.data?.data
          const selectedCountryCode = this.state.countryCodes?.find(
            (ele) => ele.value == userData?.country_code?.replace(/\+/g, '')
          )

          this.setState(
            {
              ...userData,
              pickup_data: this.state.pickupList.find((ele) => ele.value === userData?.pickup_id) || null,
              countryCodeData: selectedCountryCode,
              Edit: true,
              nationalityData:
                this.state.countryList?.find((ele) => ele.value == userData?.user_nationality_id) || null,
            },
            () => {
              if (this.props?.match?.params?.tab_type == 'wallet') {
                this.setState({
                  selected_tab: 'recharge-list',
                })
              } else if (this.props?.match?.params?.tab_type == 'voucher') {
                this.setState({
                  selected_tab: 'voucher-list',
                })
              } else if (this.props?.match?.params?.tab_type == 'user-wallet') {
                this.setState({
                  selected_tab: 'user-wallet',
                })
              }
            }
          )
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getNationalityList = () => {
    axios
      .get(Constant.getAPI() + '/admin/get-nationality', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            nationality_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getOwnerList = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/list-users/admin', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            ownerList: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = async (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleChangeImage = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
      Edit: false,
      img: URL.createObjectURL(e.target.files[0]),
    })
  }

  onSaveData = async () => {
    if (!this.state.countryCodeData) {
      Swal.fire({
        title: 'Please select a country code',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }

    const countryCode = `+${this.state.countryCodeData.value}`
    const number_validation = Constant.isPhoneNumberValid(this.state.phone, countryCode)

    if (number_validation && !number_validation.valid) {
      document.getElementById('phone')?.focus()
      Swal.fire({
        title: number_validation.msg,
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }

    if (this.state.user_type == 'captain') {
      if (this.state.captain_alloted_to.length < 1) {
        Swal.fire({
          title: 'Boat Owner should not be empty',
          icon: 'error',
          text: '',
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        return false
      } else if (this.state.nationality.length < 1) {
        Swal.fire({
          title: 'Nationality should not be empty',
          icon: 'error',
          text: '',
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        return false
      }
    }

    if (this.state.user_type === 'port-admin' && !this.state.pickup_data) {
      Swal.fire({
        title: 'Pickup location required!',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }

    this.setState({ isLoading: true })

    const formData = new FormData()

    formData.append('phone', this.state.phone)

    formData.append('first_name', this.state.first_name)
    formData.append('last_name', this.state.last_name)
    formData.append('first_name_ar', this.state.first_name_ar)
    formData.append('last_name_ar', this.state.last_name_ar)
    formData.append('country_code', this.state.countryCodeData?.value)
    formData.append('email', this.state.email)
    formData.append('password', this.state.password)
    formData.append('user_type', this.state.user_type)
    formData.append('concierge_company_name', this.state.concierge_company_name)
    formData.append('user_nationality_id', this.state.nationalityData?.value)

    if (this.state.dob) formData.append('dob', this.state.dob)
    if (this.state.gender) formData.append('gender', this.state.gender)

    if (this.state.user_type == 'captain') {
      formData.append('captain_alloted_to', this.state.captain_alloted_to)
      formData.append('nationality', this.state.nationality)
    }

    if (this.state.user_profile?.name) {
      formData.append('user_profile', this.state.user_profile)
    }

    if (this.state.user_type === 'port-admin') {
      formData.append('pickup_id', this.state.pickup_data?.value)
    }

    let request

    if (this.state?.id) {
      formData.append('userId', this.state.id)
      request = axios.post(Constant.getAPI() + '/user/edit-user', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    } else {
      request = axios.post(Constant.getAPI() + '/user/add-user', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }

    await request
      .then(() => {
        this.setState({ isLoading: false })
        Swal.fire({
          title: 'Saved Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        window.location.href = '#/all-users'
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getPickupList = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/pickup-listing', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            pickupList: res.data.data.map((itm) => ({
              label: `${itm.pickup_address_en}/${itm.pickup_address_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleClear = () => {
    this.setState({ pickup_data: null })
  }

  clearNationalityData = () => {
    this.setState({ nationalityData: null })
  }

  handleSelectNationality = (event) => {
    this.setState({ nationalityData: event })
  }

  handleCityChange = (event) => {
    this.setState({ pickup_data: event })
  }

  getCountryList = async () => {
    await axios
      .get(Constant.getAPI() + '/auth/list-countries?all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            countryList: res.data.data.map((itm) => ({
              label: `${itm.country_name_en}/${itm.country_name_ar}`,
              value: itm.id,
              country: itm.country_short_name,
            })),
            countryCodes: res.data.data.map((itm) => ({
              label: `+${itm.country_code} (${itm.country_name_en})`,
              value: itm.country_code,
              noMaxLength: itm.no_max_length,
            })),
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleCountryChange = (event) => {
    this.setState({ countryCodeData: event })
  }

  handleCountryClear = () => {
    this.setState({ countryCodeData: null })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.id ? 'Edit' : 'Add'} User</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Select Role Type</label>
                            <div className="col-md-9">
                              <select
                                disabled={this.props?.match?.params?.action == 'edit'}
                                value={this.state.user_type}
                                name="user_type"
                                className="form-control"
                                onChange={this.handleChange}
                              >
                                {/* <option value="">ALL</option> */}
                                {this.getUserType()
                                  .filter(
                                    (itm) =>
                                      this.props?.match?.params?.action == 'edit' ||
                                      (this.props?.match?.params?.action != 'edit' && itm.value != 'user')
                                  )
                                  .map((itm) => (
                                    <option
                                      value={itm.value}
                                      key={itm.value}
                                    >
                                      {itm.label}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        {this.props?.match?.params?.action == 'edit' && (
                          <>
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Account Creation At</label>
                                <div className="col-sm-9">
                                  <input
                                    disabled={true}
                                    type="text"
                                    className="form-control b-2"
                                    name="created_at"
                                    id="created_at"
                                    onChange={this.handleChange}
                                    value={moment(this.state.created_at).format('YYYY-MM-DD hh:mm A')}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.user_type === 'third-party' && (
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Token</label>
                                  <div className="col-sm-9">
                                    <input
                                      disabled={true}
                                      type="text"
                                      className="form-control b-2"
                                      name="token"
                                      id="token"
                                      value={this.state.token}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        <div
                          className="col-md-12 m-b-20"
                          style={{ borderTop: '2px solid #eee' }}
                        ></div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">First Name: English</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                name="first_name"
                                id="first_name"
                                placeholder="First Name: English"
                                onChange={this.handleChange}
                                value={this.state.first_name}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">First Name: Arabic</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                name="first_name_ar"
                                id="first_name_ar"
                                placeholder="First Name: Arabic"
                                onChange={this.handleChange}
                                value={this.state.first_name_ar}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Last Name: English</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                name="last_name"
                                id="last_name"
                                placeholder="Last Name: English"
                                onChange={this.handleChange}
                                value={this.state.last_name}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Last Name: Arabic</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                name="last_name_ar"
                                id="last_name_ar"
                                placeholder="Last Name: Arabic"
                                onChange={this.handleChange}
                                value={this.state.last_name_ar}
                              />
                            </div>
                          </div>
                        </div>
                        {this.state.user_type === 'port-admin' && (
                          <>
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Pickup Location</label>
                                <div className="col-sm-9">
                                  <Select
                                    name="pickup_data"
                                    value={this.state.pickup_data}
                                    onChange={this.handleCityChange}
                                    options={this.state.pickupList}
                                    isMulti={false}
                                    isSearchable={true}
                                    isClearable
                                    onClear={this.handleClear}
                                    placeholder="Select Option"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6"></div>
                          </>
                        )}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Date Of Birth</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                className="form-control"
                                name="dob"
                                id="dob"
                                max={moment().format('YYYY-MM-DD')}
                                placeholder="Date of Birth"
                                onChange={this.handleChange}
                                value={this.state.dob}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Gender</label>
                            <div className="col-sm-9">
                              <select
                                name="gender"
                                className="form-control"
                                value={this.state.gender}
                                onChange={this.handleChange}
                              >
                                <option>Select Gender</option>
                                <option value="M">Male</option>
                                <option value="F">Female</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country Code</label>
                            <div className="col-sm-9">
                              <Select
                                name="countryCodeData"
                                value={this.state.countryCodeData}
                                onChange={this.handleCountryChange}
                                options={this.state.countryCodes}
                                isMulti={false}
                                isSearchable={true}
                                isClearable
                                onClear={this.handleCountryClear}
                                placeholder="Select Options"
                                styles={{
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                    position: 'absolute',
                                    width: '100%',
                                  }),
                                }}
                              />
                              {/* <select
                                name="country_code"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.country_code}
                              >
                                <option value="">Select Country Code</option>
                                <option value="+965">+965 (Kuwait)</option>
                                <option value="+974">+974 (Qatar)</option>
                                <option value="+966">+966 (Saudi Arabia)</option>
                                <option value="+971">+971 (United Arab Emirates)</option>
                              </select> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Phone No</label>
                            <div className="col-sm-9">
                              <input
                                type="number"
                                className="form-control"
                                name="phone"
                                id="phone"
                                placeholder="Phone No"
                                onChange={this.handleChange}
                                value={this.state.phone}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Select Nationality</label>
                            <div className="col-sm-9">
                              <Select
                                name="nationalityData"
                                value={this.state.nationalityData}
                                onChange={this.handleSelectNationality}
                                options={this.state.countryList}
                                isMulti={false}
                                isSearchable={true}
                                isClearable
                                onClear={this.clearNationalityData}
                                placeholder="Select Options"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Email</label>
                            <div className="col-sm-9">
                              <input
                                type="email"
                                className="form-control"
                                name="email"
                                id="email"
                                placeholder="Email"
                                onChange={this.handleChange}
                                value={this.state.email}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Password</label>
                            <div className="col-sm-9">
                              <input
                                type="password"
                                className="form-control"
                                autoComplete="new-password"
                                name="password"
                                id="password"
                                placeholder="Password"
                                onChange={this.handleChange}
                                value={this.state.password}
                              />
                            </div>
                          </div>
                        </div>
                        {this.state.user_type == 'captain' && (
                          <>
                            <div
                              className="col-md-12 m-b-20"
                              style={{ borderTop: '2px solid #eee' }}
                            ></div>

                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Boat Owner</label>
                                <div className="col-sm-9">
                                  <select
                                    name="captain_alloted_to"
                                    className="form-control"
                                    onChange={this.handleChange}
                                    value={this.state.captain_alloted_to}
                                  >
                                    <option value="">Select Boat Owner</option>
                                    {this.state.ownerList.map((data) => (
                                      <option
                                        value={data.id}
                                        key={data.id}
                                      >
                                        {data.first_name} {data.last_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Nationality</label>
                                <div className="col-sm-9">
                                  <select
                                    name="nationality"
                                    className="form-control"
                                    onChange={this.handleChange}
                                    value={this.state.nationality}
                                  >
                                    <option value="">Select Nationality</option>
                                    {this.state.nationality_list.map(({ id, name_en, name_ar }) => (
                                      <option
                                        value={id}
                                        key={id}
                                      >
                                        {name_en}
                                        {' / '}
                                        {name_ar}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div
                              className="col-md-12 m-b-20"
                              style={{ borderTop: '2px solid #eee' }}
                            ></div>
                          </>
                        )}
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-sm-3"> Image</div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <div>
                                  <input
                                    type="file"
                                    id="img"
                                    name="user_profile"
                                    accept="image/*"
                                    className="w-100"
                                    onChange={this.handleChangeImage}
                                  />
                                </div>
                              </div>
                              {this.state.Edit ? (
                                <img
                                  width="250px"
                                  src={Constant.getImage() + this.state.user_profile}
                                  alt="img"
                                  onError={({ currentTarget }) => {
                                    currentTarget.src = './assets/images/no_image.png'
                                  }}
                                />
                              ) : (
                                <img
                                  width="250px"
                                  src={this.state.img}
                                  alt="img"
                                  onError={({ currentTarget }) => {
                                    currentTarget.src = './assets/images/no_image.png'
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        {this.state.user_type === 'concierge' && (
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Company name</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="concierge_company_name"
                                  id="concierge_company_name"
                                  placeholder="Concierge Company Name"
                                  onChange={this.handleChange}
                                  value={this.state.concierge_company_name}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="row float-right p-3">
                        <Button
                          disabled={this.state.isLoading}
                          onClick={this.onSaveData}
                          startIcon={<i className="icofont icofont-save"></i>}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.user_type == 'user' && this.props?.match?.params?.id ? (
            <>
              <ul
                className="nav nav-tabs tabs"
                role="tablist"
              >
                {this.state.user_tabs.map((item) => (
                  <li
                    className="nav-item"
                    key={item.value}
                    onClick={() => {
                      this.setState({
                        selected_tab: item.value,
                      })
                    }}
                  >
                    <a
                      className={this.state.selected_tab === item.value ? 'nav-link active' : 'nav-link'}
                      id={item.value}
                      data-toggle="tab"
                      role="tab"
                      aria-controls={item.value}
                      aria-selected="true"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
              <div className="tab-content tabs">
                <div
                  className="tab-pane active"
                  id={this.state.selected_tab}
                  role="tabpanel"
                  aria-labelledby=""
                >
                  {this.state.selected_tab == 'booking-history' && (
                    <BookingHistory customer_id={this.props?.match?.params?.id} />
                  )}
                  {this.state.selected_tab == 'user-wallet' && (
                    <WalletHistory customer_id={this.props?.match?.params?.id} />
                  )}
                  {this.state.selected_tab == 'user-loyalty-points' && (
                    <LoyaltyPointHistory customer_id={this.props?.match?.params?.id} />
                  )}
                  {this.state.selected_tab == 'voucher-list' && (
                    <VoucherHistory customer_id={this.props?.match?.params?.id} />
                  )}
                  {this.state.selected_tab == 'recharge-list' && (
                    <RechargeHistory customer_id={this.props?.match?.params?.id} />
                  )}
                </div>
              </div>
            </>
          ) : (
            ''
          )}
        </div>
      </div>
    )
  }
}

export default AddNewUser
